var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9596 48.6H52.041C53.4522 48.6 54.6 47.3802 54.6 45.9684V15.699C54.6 15.6936 54.6018 15.7248 54.6018 15.7194C54.6018 14.3106 53.4534 13.2 52.0416 13.2H52.0404H8.1672H7.959C6.5478 13.2 5.4 14.277 5.4 15.6882V45.9684C5.4 47.3802 6.5478 48.6 7.9596 48.6ZM23.115 29.4732L7.8 44.6652V17.934L23.115 29.4732ZM52.2 18.1116V43.485L37.7484 29.1486L52.2 18.1116ZM35.8338 30.612C35.8602 30.6438 35.883 30.7134 35.913 30.744L51.4584 46.2H9.7326L25.0524 30.9678L29.541 34.332C29.7546 34.4928 30.0084 34.5648 30.2628 34.5648C30.5196 34.5648 30.7758 34.4784 30.9912 34.314L35.8338 30.612ZM51.6282 15.6L30.2586 31.9212L8.5956 15.6H51.6282Z",
    fill: "#052850"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.92368b33250faad69f0f780a478ac209.svg";
export { ForwardRef as ReactComponent };